function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9167 0C14.8867 0 12.9383 0.945 11.6667 2.43833C10.395 0.945 8.44667 0 6.41667 0C2.82333 0 0 2.82333 0 6.41667C0 10.8267 3.96667 14.42 9.975 19.88L11.6667 21.4083L13.3583 19.8683C19.3667 14.42 23.3333 10.8267 23.3333 6.41667C23.3333 2.82333 20.51 0 16.9167 0ZM11.7833 18.1417L11.6667 18.2583L11.55 18.1417C5.99667 13.1133 2.33333 9.78833 2.33333 6.41667C2.33333 4.08333 4.08333 2.33333 6.41667 2.33333C8.21333 2.33333 9.96333 3.48833 10.5817 5.08667H12.7633C13.37 3.48833 15.12 2.33333 16.9167 2.33333C19.25 2.33333 21 4.08333 21 6.41667C21 9.78833 17.3367 13.1133 11.7833 18.1417Z",
  fill: "black"
});

var SvgIconLove1 = function SvgIconLove1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLove1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-love-1.4c1b8ba5.svg";
export { ForwardRef as ReactComponent };